module.exports = __webpack_public_path__ + "img/keeDarkLogoWithTagline.716f3985.png";